import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { defineMessages } from 'react-intl';

import { TeamsCardIllustrationDark } from '../assets/TeamsCardIllustrationDark';

import { TeamsCardIllustrationLight } from '../assets/TeamsCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

export const TeamsOnboardingCard = (props: CarouselCardProps): JSX.Element => {
	const images: CardImages = {
		component: <TeamsCardIllustrationLight />,
		componentDark: <TeamsCardIllustrationDark />,
	};
	return (
		<CarouselBaseCard
			messages={{ ...teamsMessages, ...commonTwcMessages }}
			images={images}
			{...props}
		/>
	);
};

const teamsMessages = defineMessages({
	heading: {
		defaultMessage: 'Collaborate with teams',
		description: 'Heading for the Teams onboarding card',
		id: 'townsquare.twc-onboarding-widget.teams-card.heading',
	},
	description: {
		defaultMessage: 'Collaborate more with teams and unlock the power of your teammates.',
		description: 'Description for the Teams onboarding card',
		id: 'townsquare.twc-onboarding-widget.teams-card.description',
	},
	cta: {
		defaultMessage: 'Try Teams',
		description: 'Call to action text for the Teams onboarding card',
		id: 'townsquare.twc-onboarding-widget.teams-card.cta',
	},
});
